import { useEffect, useRef } from 'react';
import beTwMerge from '@/utils/beTwMerge';

/*
    Global-E will search and inject the country selector here. But it does that only once in the entire page life cycle.
    If one of these components receives "injectGbleCountry=true", it will:

    1. Search the html element previously injected by Global-E.
    2. Inject the html element inside this container *instance*.

    TODO: Ideally, gble will expose an api to inject the country selector programatically.
*/

type Props = {
  injectGlbeCountry: boolean;
  className?: string;
};

export default function GbleCountries({ injectGlbeCountry, className }: Props) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!injectGlbeCountry) return;

    const id = setInterval(() => {
      // Not a react element. Injected by Global-E in another "GbleCountries" element.
      const glbeElement = document.querySelector('.ge-flag-show.ge-switcher-flag');

      if (glbeElement) {
        container.current?.appendChild(glbeElement);
        clearInterval(id);
      }
    }, 500);
    return () => clearInterval(id);
  }, [injectGlbeCountry]);

  return (
    <div
      ref={container}
      className={beTwMerge(
        // INFO: Global-E will search for this class name !!
        'list-inline site-header-personal tw-pointer-events-auto',
        className
      )}
    />
  );
}
